export const playlist = {
  'Public playlist': 'Playlist pubblica',
  songs: 'canzoni',
  Name: 'Nome',
  Skills: 'Competenze',
  Filter: 'Filtra',
};
